/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessSourceMonthlyStat } from './BusinessSourceMonthlyStat';
import {
    BusinessSourceMonthlyStatFromJSON,
    BusinessSourceMonthlyStatFromJSONTyped,
    BusinessSourceMonthlyStatToJSON,
    BusinessSourceMonthlyStatToJSONTyped,
} from './BusinessSourceMonthlyStat';

/**
 * 
 * @export
 * @interface MonthlyBusinessSource
 */
export interface MonthlyBusinessSource {
    /**
     * 月份（1-12）
     * @type {number}
     * @memberof MonthlyBusinessSource
     */
    month?: number;
    /**
     * 各业务类型来源统计
     * @type {Array<BusinessSourceMonthlyStat>}
     * @memberof MonthlyBusinessSource
     */
    types?: Array<BusinessSourceMonthlyStat>;
}

/**
 * Check if a given object implements the MonthlyBusinessSource interface.
 */
export function instanceOfMonthlyBusinessSource(value: object): value is MonthlyBusinessSource {
    return true;
}

export function MonthlyBusinessSourceFromJSON(json: any): MonthlyBusinessSource {
    return MonthlyBusinessSourceFromJSONTyped(json, false);
}

export function MonthlyBusinessSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthlyBusinessSource {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'] == null ? undefined : json['month'],
        'types': json['types'] == null ? undefined : ((json['types'] as Array<any>).map(BusinessSourceMonthlyStatFromJSON)),
    };
}

export function MonthlyBusinessSourceToJSON(json: any): MonthlyBusinessSource {
    return MonthlyBusinessSourceToJSONTyped(json, false);
}

export function MonthlyBusinessSourceToJSONTyped(value?: MonthlyBusinessSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'types': value['types'] == null ? undefined : ((value['types'] as Array<any>).map(BusinessSourceMonthlyStatToJSON)),
    };
}

